import { hasTracking } from "@escapio/shared/state/client-settings";

/*
 * This fallback is to prevent JS errors for the cases:
 * - if an event is tracked before the snippet completed loaded
 * - if the snippet loading was blocked
 * - if we forget to include the Google Snippet in the page.
 */
if (window.gtag === undefined) {
	window.dataLayer = window.dataLayer || [];
	window.gtag = (...args) => window.dataLayer.push(args);
}

export function track() {
	if (!hasTracking) return;
	window.gtag("event", "conversion", {
		send_to: "AW-1016934296/lv8eCIu2jIMBEJjf9OQD",
	});
}
